import { PureComponent } from "react";
import ShortFooter from "components/core/short-footer/short-footer";

export default class ShortFooterComponent extends PureComponent {
  render() {
    return <ShortFooter {...this.props} />;
  }
}
